import { render, staticRenderFns } from "./CustomAudienceFb.vue?vue&type=template&id=46ee3272&scoped=true&lang=pug"
import script from "./CustomAudienceFb.vue?vue&type=script&lang=js"
export * from "./CustomAudienceFb.vue?vue&type=script&lang=js"
import style0 from "./CustomAudienceFb.vue?vue&type=style&index=0&id=46ee3272&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ee3272",
  null
  
)

export default component.exports